<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="800px"
    :innerScroll="false"
    @close="onCancel"
    :loading="loadingBtn"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="requestParam" :rules="rules" ref="requestParam" v-loading="loading">
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="层级" prop="tag" label-width="80px">
            <el-select v-model="requestParam.tag" :disabled="isEdit" style="width: 100%" @change="handleTagChange" size="small" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="对象类型" prop="optionType" label-width="80px">
            <el-select
              v-model="requestParam.optionType"
              :disabled="isEdit"
              style="width: 100%"
              size="small"
              placeholder="请选择"
              @change="handleOptionTypeChange"
            >
              <el-option v-for="item in baseTypeList" :key="item.index" :label="item.name" :value="item.index"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15" v-for="(item, index) in requestParam.list" :key="index">
        <el-col :span="12">
          <el-form-item label="顺序" :prop="`list.${index}.sort`" :rules="rules.sort" label-width="80px">
            <el-input style="width: 100%" v-model.trim="item.sort" autocomplete="off" size="small" maxlength="7"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="requestParam.optionType == '38'" label="描述" :prop="`list.${index}.optionValue`" :rules="rules.shopCode" label-width="80px">
            <div class="desc-input-wrap">
              <el-select v-model="item.optionValue" class="desc-input" size="small" placeholder="请选择">
                <el-option v-for="storeItem in toStoreBox" :key="storeItem.index" :label="storeItem.shopName" :value="storeItem.shopName"> </el-option>
              </el-select>
              <el-button type="text" v-if="!isEdit && index == 0" @click="add" size="small" class="action-btn">添加</el-button>
              <el-button type="text" v-if="!isEdit && index != 0" @click="deleteObj(index)" size="small" class="action-btn">删除</el-button>
            </div>
          </el-form-item>
          <el-form-item v-else label="描述" :prop="`list.${index}.optionValue`" :rules="rules.optionValue" label-width="80px">
            <div class="desc-input-wrap">
              <el-input v-model.trim="item.optionValue" autocomplete="off" size="small" class="desc-input" maxlength="80"></el-input>
              <el-button type="text" v-if="!isEdit && index == 0" @click="add" size="small" class="action-btn">添加</el-button>
              <el-button type="text" v-if="!isEdit && index != 0" @click="deleteObj(index)" size="small" class="action-btn">删除</el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: "ConfigEdit",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    searchFormData: {
      type: Object,
      default: () => ({}),
    },
    toStoreBox: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return this.isEdit ? "修改配置" : "新增配置";
    },
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      options: [
        { value: 1, label: "SPU" },
        { value: 2, label: "SKU" },
        { value: 3, label: "产品" },
        { value: 4, label: "包件" },
      ],
      baseTypeList: [],
      requestParam: {
        tag: null,
        optionType: "",
        list: [{ sort: null, optionValue: "" }],
      },
      rules: {
        tag: [{ required: true, message: "请选择层级", trigger: "blur" }],
        optionType: [{ required: true, message: "请输入对象类型", trigger: "blur" }],
        sort: [
          { required: true, message: "请输入顺序", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value && (/^[1-9]\d*$/.test(value) === false || Number(value) > 9999999)) {
                callback(new Error("顺序请输入1-9999999的正整数"));
              } else {
                callback();
              }
            },
          },
        ],
        optionValue: [{ required: true, message: "请输入描述", trigger: "blur" }],
        shopCode: [{ required: true, message: "请输入描述", trigger: "blur" }],
      },
      matchedDataLength: 0,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.isEdit && this.rowData.id) {
        // 编辑模式
        this.requestParam = {
          id: this.rowData.id,
          tag: this.rowData.tag,
          optionType: this.rowData.optionType,
          list: [{ sort: this.rowData.sort, optionValue: this.rowData.optionValue }],
        };
        this.getBaseType(this.rowData.tag);
      } else {
        // 新增模式
        const filterData = this.searchFormData.filterData || {};
        this.requestParam = {
          tag: filterData.tag || null,
          optionType: filterData.optionType || "",
          list: [{ sort: null, optionValue: "" }],
        };
        if (filterData.tag) {
          this.getBaseType(filterData.tag);
        }
      }
    },
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      // 验证顺序不能相同
      if (this.verification()) {
        return;
      }
      this.$refs.requestParam.validate((valid) => {
        if (!valid) return;
        this.loadingBtn = true;
        this.requestParam.list.forEach((v) => {
          this.toStoreBox.forEach((i) => {
            if (i.shopName == v.optionValue) {
              v.shopCode = i.shopCode;
            }
          });
        });
        this.$q.goods
          .addConfig({ data: JSON.stringify(this.requestParam) })
          .then((res) => {
            if (res.success) {
              let message = this.title + "成功";
              this.$message.success(message);
              this.isVisible = false;
              this.$emit("success");
            } else {
              this.$message.error(res.message);
            }
          })
          .finally(() => {
            this.loadingBtn = false;
          });
      });
    },
    verification() {
      const list = this.requestParam.list;
      let flag = false;
      for (let i = 0; i < list.length - 1; i++) {
        for (let j = i + 1; j < list.length; j++) {
          if (list[i].sort == list[j].sort) {
            flag = true;
            break;
          }
        }
        if (flag) {
          break;
        }
      }
      if (flag) {
        this.$message.error("同一层级，同一对象类型顺序不能相同！");
        return true;
      }
      return false;
    },
    handleTagChange(val) {
      this.requestParam.optionType = "";
      this.getBaseType(val);
      this.get_matchedDataLength();
    },
    handleOptionTypeChange() {
      this.get_matchedDataLength();
    },
    getBaseType(value) {
      this.$q.goods.getBaseType({ params: { tagType: value } }).then((res) => {
        this.baseTypeList = res.data;
      });
    },
    get_matchedDataLength() {
      if (this.requestParam.tag && this.requestParam.optionType) {
        let data = {
          pageNum: 1,
          pageSize: 100000,
          filterData: {
            tag: this.requestParam.tag,
            optionType: this.requestParam.optionType,
          },
        };
        this.$q.goods.listPage({ data: data }).then((res) => {
          if (res.data.records && res.data.records.length > 0) {
            this.matchedDataLength = res.data.records[res.data.records.length - 1].sort;
            this.requestParam.list[0].sort = this.matchedDataLength + 1;
          }
        });
      }
    },
    add() {
      this.requestParam.list.push({
        sort: this.requestParam.list[this.requestParam.list.length - 1].sort + 1,
        optionValue: "",
      });
    },
    deleteObj(index) {
      this.requestParam.list.splice(index, 1);
    },
  },
};
</script>

<style lang="stylus" scoped>
.desc-input-wrap
  display flex
  align-items center
.desc-input
  flex 1
>>> .desc-input.el-input
  width auto !important
>>> .desc-input .el-input__inner
  width 100% !important
.action-btn
  margin-left 5px !important
  padding 0 !important
.dialog-footer
  text-align right
  padding-top 20px
</style>
